module.exports = __webpack_public_path__ + "static/media/ic-lock.72affe45.svg";